import { render, staticRenderFns } from "./SidebarRow.vue?vue&type=template&id=10c3d8a6&scoped=true&"
import script from "./SidebarRow.vue?vue&type=script&lang=ts&"
export * from "./SidebarRow.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarRow.vue?vue&type=style&index=0&id=10c3d8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3d8a6",
  null
  
)

export default component.exports